module.exports = __webpack_public_path__ + "static/media/change_oneself.1283df10.png";